export type ClassValue = false | string | null | undefined;

/** Tiny classnames helper: joins truthy class strings. */
export const cx = (...parts: ReadonlyArray<ClassValue>): string =>
  parts.filter(Boolean).join(" ");
